/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_SubscriptionsInputs */

const en_admin_nav_subscriptions = /** @type {(inputs: Admin_Nav_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const zh_admin_nav_subscriptions = /** @type {(inputs: Admin_Nav_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Admin_Nav_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_subscriptions = /** @type {((inputs?: Admin_Nav_SubscriptionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_SubscriptionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_subscriptions(inputs)
	return zh_admin_nav_subscriptions(inputs)
});
export { admin_nav_subscriptions as "admin.nav.subscriptions" }